export default "__VITE_ASSET__DkoMrAd___"